var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"loan-agreement-wrapper"},[_c('iframe',{staticClass:"pdf-wrapper",attrs:{"src":"https://jydpro.jinr.com/uploadsFiles/jyd/static/agreement.pdf","frameborder":"0"}})])])
}]

export { render, staticRenderFns }